import { Portal, useMenuContext } from "@chakra-ui/react";

export const MenuPortal: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isLazy, isOpen } = useMenuContext();
  return isLazy && !isOpen ? null : <Portal>{children}</Portal>;
};
